/**
 * Shared Tailwind class strings for form-builder controls so palette, canvas, and
 * rows stay visually consistent when focus rings or layout tokens change.
 */
export const BUILDER_CONTROL_FOCUS =
	"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 focus-visible:ring-offset-background-primary";
